var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerpoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 52",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.805 4l.967 23.687-24.195-4.69.005-.027c.842-5.715 3.65-10.476 7.632-13.828l.326-.269A21.992 21.992 0 0127.805 4z",
    stroke: "#ED6C47",
    strokeWidth: 2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.825 4.023c6.157.265 11.51 2.776 15.443 6.709a22.913 22.913 0 016.731 16.035L48.31 29H27.075z",
    stroke: "#FF8F6B",
    strokeWidth: 2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.975 27.261c-.265 5.776-2.664 10.94-6.414 14.732A21.892 21.892 0 0127 48.512h-.509a21.998 21.998 0 01-15.54-6.463 21.995 21.995 0 01-6.438-14.543z",
    stroke: "#D35230",
    strokeWidth: 2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.744 15.593v22.488a2.144 2.144 0 01-2.128 2.128H8.046a22.807 22.807 0 01-4.558-13.697V26a22.739 22.739 0 013.745-12.535h17.383a2.144 2.144 0 012.128 2.128z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.581 15.593v22.488a2.144 2.144 0 01-2.127 2.128H8.047a22.807 22.807 0 01-4.559-13.697V26a22.739 22.739 0 013.745-12.535h16.22a2.144 2.144 0 012.128 2.128z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.131 13.465H23.45a2.13 2.13 0 012.131 2.131v21.32a2.131 2.131 0 01-2.131 2.13H2.131A2.131 2.131 0 010 36.917v-21.32a2.13 2.13 0 012.131-2.13z",
    fill: "#BE3819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.023 19.15a5.86 5.86 0 013.882 1.137 4.07 4.07 0 011.35 3.294 4.584 4.584 0 01-.665 2.462 4.452 4.452 0 01-1.892 1.672 6.424 6.424 0 01-2.846.598h-2.696v5.011H7.394V19.15h5.63zm-2.87 6.998h2.377a3.086 3.086 0 002.101-.627 2.326 2.326 0 00.71-1.834c0-1.562-.907-2.343-2.722-2.343h-2.466v4.804z",
    fill: "#FFF"
  }))));
}
export default SvgPowerpoint;